import * as React from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import ForgottenPasswordForm from './components/CreateAnAccountForm';
import { Button } from 'react-bootstrap';
import { IStore } from '../../../../redux/IStore';
import Heap from '../../../../helpers/Heap';

interface ICreateAnAccountProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
}

class CreateAnAccount extends React.Component<ICreateAnAccountProps> {
  private handleSubmit = (values) => {
    const { actions } = this.props;

    actions.auth.createAccount(values.email);
  }

  private handleGoBack = () => {
    const { actions } = this.props;
    actions.push('/auth/login');
  }

  private handleNewQuoteClick = () => {
    Heap.track('NewQuoteFromCreateAccount', {});
    window.location.href = '/';
  }

  private renderWarningMessage = () => {
    if (this.props.auth.noAccount) {
      return (
        <div className="blue-section">
          <p>We don’t have any records matching your details.</p>
          <p style={{ marginBottom: 0 }}>To create an account, please complete a quote here: </p>
          <p onClick={this.handleNewQuoteClick} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Admiral Insurance: Start New Quote</p>
          <p>We have sent you an email with further information.</p>
        </div>
      )
    }

    return (
      <div className="blue-section">
        <p>We have emailed you with a link to verify your email address and set your password.</p>
        <p> If you don’t receive the email within five minutes, please check your Junk folder.</p>
        <p>Note: the link in the email will expire in 24 hours.</p>
      </div>
    )
  }

  public render() {
    const { auth } = this.props;

    return (
      <div className="page-container">
        <div className="login-form">
          <div className="customer-section-title">
            <div className={'login-form-title button'}>
              <div style={{ flex: 1 }}>Create an account</div>
              <div style={{ flex: 1 }} className={'return-to-login-btn'}>
                <Button
                  onClick={this.handleGoBack}
                  bsStyle="primary"
                  type="submit"
                  className="secondary-button login-button-sub-2"
                >
                  Return to sign in page
                </Button>
              </div>
            </div>
            <h4 style={{ padding: '0 15px 0 15px', color: '#2350A0' }}>
              Please provide the information below, in order to create your account
            </h4>
          </div>
          {
            !auth.createAccount && !auth.noAccount ? (
              <div className={'white-card'}>
                <ForgottenPasswordForm onSubmit={this.handleSubmit}/>
              </div>
            ) : this.renderWarningMessage()
          }
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'create-an-account',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('create-an-account');

    return component;
  },
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(CreateAnAccount);
